import { render, staticRenderFns } from "./AddGroupDistributor.vue?vue&type=template&id=2330a6de&"
import script from "./AddGroupDistributor.vue?vue&type=script&lang=js&"
export * from "./AddGroupDistributor.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports